import { ASSESSMENTGREY_ICON, CORPORATE_ICON, DASHBOARDGREY_ICON, LOGOUTICON, RESULTGREY_ICON, ROLEACCESSGREY_ICON, STAFFGREY_ICON } from "../../../utills/image-constant";
import { ROUTES } from "../../routes/url-constant";

export const menuData = [
    {
        id: 1,
        name: "Dashboard",
        icon: DASHBOARDGREY_ICON,
        url: ROUTES.DASHBOARD,
        code: "dashboard",
        subItems: null,
    },
    {
        id: 2,
        name: "Team Management",
        icon: ROLEACCESSGREY_ICON,
        url: ROUTES.ADMINROLE,
        code: "Team Management",
        subItems: [
            {
                id: 1,
                name: "Team Role Access",
                url: ROUTES.ADMINROLE,
                code: "Team Role Accesst",
                subItems: null,
            },
            {
                id: 2,
                name: "Team Employees",
                url: ROUTES.EMPLOYEEMANAGEMENT,
                code: "Team Employees",
                subItems: null,
            },
        ],
    },
    {
        id: 3,
        name: "Assessment Modeling",
        icon: ASSESSMENTGREY_ICON,
        url: null,
        code: "Assessment Modeling",
        subItems: [
            {
                id: 1,
                name: "Model Management",
                url: ROUTES.MODALTABLE,
                code: "Model Management",
                subItems: null,
            },
            {
                id: 2,
                name: "Dimension Management",
                url: ROUTES.DIMENSIONTABLE,
                code: "Dimension Management",
                subItems: null,
            },
            {
                id: 3,
                name: "Sub-Dimension Management",
                url: ROUTES.SUBDIMENSIONTABLE,
                code: "Sub-Dimension Management",
                subItems: null,
            },
            {
                id: 4,
                name: "Criteria Management",
                url: ROUTES.CRITERIATABLE,
                code: "Criteria Management",
                subItems: null,
            },
            {
                id: 5,
                name: "Bulk Upload",
                url: ROUTES.BULKUPLOAD,
                code: "Bulk Upload",
                subItems: null,
            },
        ]
    },
    {
        id: 4,
        name: "Customer Management",
        icon: CORPORATE_ICON,
        url: null,
        code: "Customer Management",
        subItems: [
            {
                id: 1,
                name: "Company Management",
                url: ROUTES.COMPANYMANAGEMENT,
                code: "Company Management",
                subItems: null,
            },
            {
                id: 2,
                name: "Employee Management",
                url: ROUTES.COMPANYEMPLOYEEMANAGEMENT,
                code: "Employee Management",
                subItems: null,
            },
            {
                id: 3,
                name: "Assessor management",
                url: ROUTES.ASSESSORMANAGEMENT,
                code: "Assessor Management",
                subItems: null,
            },

        ]
    },
    {
        id: 5,
        name: "Campaign Management",
        icon: STAFFGREY_ICON,
        url: "",
        code: "Campaign Management",
        subItems: [
            {
                id: 1,
                name: "Campaign Setup",
                url: ROUTES.VIEWASSIGNEDASSESSMENTS,
                code: "Campaign Setupt",
                subItems: null,
            },
            // {
            //     id: 2,
            //     name: "Assessor",
            //     url: ROUTES.ONSITE,
            //     code: "Assessor",
            //     subItems: null,
            // },

        ],
    },
    {
        id: 6,
        name: "Assessor",
        icon: ASSESSMENTGREY_ICON,
        url: ROUTES.ONSITE,
        code: "Assessor",
        // subItems: [
        //     {
        //         id: 1,
        //         name: "Individual Result",
        //         url: ROUTES.ONSITE,
        //         code: "Individual Result",
        //         subItems: null,
        //     },


        // ]
    },
    {
        id: 7,
        name: "Result",
        icon: RESULTGREY_ICON,
        url: ROUTES.INDIVISUALRESULT,
        code: "Result",
        subItems: [
            {
                id: 1,
                name: "Individual Result",
                url: ROUTES.INDIVISUALRESULT,
                code: "Individual Result",
                subItems: null,
            },
            {
                id: 2,
                name: "Overall Result",
                url: ROUTES.NEWRESULT,
                code: "Overall Result",
                subItems: null,
            },
            {
                id: 3,
                name: "Download Result",
                url: ROUTES.VIEWUSERWISERESULT,
                code: "Download Result",
                subItems: null,
            },
        ]
    },
    {
        id: 8,
        name: "Logout",
        icon: LOGOUTICON,
        url: null,
        code: "Logout",
        subItems: null,
    },
]